import { BaseApiClient } from '@/services/baseApiClient';
import type { RequestOptions } from '@/utils/request';
import { getQuery } from '@/components/filter/helpers';
import type { SerializedLease, ViewLeases } from '@enmon/commons/lib/enmon';
import type {
  CreateLeaseArgs,
  CreateLeasesArgs,
  DeleteLeaseArgs,
  GetLeasesArgs,
  GetOneLeaseArgs,
  UpdateLeaseArgs,
} from './types/args';
import type {
  DeleteLeaseResult,
  GetLeasesResult,
  GetOneLeaseResult,
  UpdateLeaseResult,
  CreateLeaseResult,
  CreateLeasesResult,
} from './types/results';

export class LeasesApiClient extends BaseApiClient {
  constructor() {
    super('api/leases');
  }

  public create(payload: CreateLeaseArgs): Promise<CreateLeaseResult> {
    return this.http.post('', payload);
  }

  public async createMany(args: CreateLeasesArgs): Promise<CreateLeasesResult> {
    return await Promise.all(args.map(item => this.create(item)));
  }

  public get<TDefault extends SerializedLease>(
    filter: GetLeasesArgs,
    view: ViewLeases,
    signal: RequestOptions['signal'],
  ): Promise<GetLeasesResult<TDefault>> {
    return this.http.get('', { query: getQuery({ ...filter, view }), signal });
  }

  public getOne(id: GetOneLeaseArgs, signal: RequestOptions['signal']): Promise<GetOneLeaseResult> {
    return this.http.get(`${id}`, { signal });
  }

  public update({ id, payload }: UpdateLeaseArgs): Promise<UpdateLeaseResult> {
    return this.http.patch(`${id}`, payload);
  }

  public delete(id: DeleteLeaseArgs): Promise<DeleteLeaseResult> {
    return this.http.delete(`${id}`);
  }
}
